import { combineReducers } from 'redux'

import jobsearch from './jobs/jobsearch'

import * as profileActions from '../actions/jobsearch'
import { JOBSEARCH_COMPARISON, JOBSEARCH_SEARCH_ITEMS } from '../actions/jobsearch'
import * as h2Api from '../h2Api'

const initialState = {
  selected: [],
  error: null
}
const jobComparisonReducer = (state = initialState, action) => {
  switch (action.type) {
    case profileActions.JOBSEARCH_COMPARISON_SET_ERROR:
      return {
        ...state,
        error: action.error
      }

    case profileActions.REMOVE_JOB_FOR_COMPARISON:
      return {
        ...state,
        selected: state.selected.filter(i => i !== action.id)
      }

    case profileActions.CLEAR_JOBSEARCH_COMPARISON:
      return {
        ...state,
        selected: []
      }

    case profileActions.SELECT_JOB_FOR_COMPARISON:
      if (state.selected.indexOf(action.id) >= 0) {
        return state
      }

      return {
        ...state,
        selected: [...state.selected, action.id]
      }

    default:
      return state
  }
}
const jobs = combineReducers({
  jobsearch,
  jobsearchRequest: h2Api.restReducer(JOBSEARCH_SEARCH_ITEMS),
  comparison: jobComparisonReducer,
  comparisonResponse: h2Api.restReducer(JOBSEARCH_COMPARISON)
})

export default jobs
